import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainUnbindDeviceQRCode(id) {
  return maintainRequest.post(
    `/device/maintenanceMan/deviceQRCode/unbindDeviceQrCode/${id}`
  );
}
